import type React from 'react';
import { Icon, Tooltip, Text } from '@nimbus-ds/components';
import { InfoCircleIcon } from '@nimbus-ds/icons';
import { CurrencyType } from '@tiendanube/common';
import AmountDto from '@tiendanube/common/dist/src/domains/payments/refund/AmountDto';
import { Country } from '@tiendanube/common/src/enums';
import { DataList } from '@tiendanube/components';
import { CurrencyPrice, Stack } from 'commons/components';
import { useGetCountry } from 'domains/Auth/hooks';
import { useNuvemPagoRedirect } from 'domains/Orders/Orders/pages/hooks';
import useTranslationOrders from '../../../useTranslationOrders';

interface Attributes {
  refundedMerchantChargesTotal: AmountDto;
  defaultCurrency: CurrencyType;
  gateway?: string;
}

function OrderRefundedMerchantChargeRow({
  refundedMerchantChargesTotal,
  defaultCurrency,
  gateway,
}: Readonly<Attributes>): React.JSX.Element {
  const t = useTranslationOrders('orderSummaryCard.tableAmounts');
  const country = useGetCountry();
  const { isNuvemPagoCommonsPayment } = useNuvemPagoRedirect(gateway ?? '');

  const isPagoNubeArgentina =
    isNuvemPagoCommonsPayment() && country === Country.AR;

  const tooltipText = t('refundedCharges.tooltip');

  return (
    <DataList.Row id="refund_merchant_charge_details">
      <DataList.Cell width={70}>
        <Stack gap="1">
          <Text color="neutral-textHigh">{t('refundedCharges.generic')}</Text>
          {isPagoNubeArgentina && !!tooltipText && (
            <Tooltip content={tooltipText} position="bottom" arrow>
              <Icon source={<InfoCircleIcon size="small" />} />
            </Tooltip>
          )}
        </Stack>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <CurrencyPrice
          price={Number(refundedMerchantChargesTotal?.value ?? 0)}
          currency={refundedMerchantChargesTotal?.currency ?? defaultCurrency}
          block
          textAlign="right"
        />
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderRefundedMerchantChargeRow;
